import http from '@/lib/http.js';
import * as localForage from 'localforage';
import nanoid from 'nanoid';

let store = localForage.createInstance({
	name: 'test',
	driver: localForage.LOCALSTORAGE
});

let mode = window.mode;

function Storage() {
	this.mode = 'localstorage';

	this.get = async function(key) {
		let res = await store.getItem(key);
		return res;
	};

	this.set = async function(key, data) {
		let res = await store.setItem(key, data);
		return res;
	};

	this.remove = async function(key) {};
}

let storage = new Storage();

function createFolder(data) {
	data._id = nanoid();
	return data;
}

function createBucket(data) {
	data._id = nanoid();
	return data;
}

export default {
	init: function() {
		mode = window.mode;
		console.log(mode);
	},

	folders: {
		async getFolders() {
			let res = [];
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/folders/all');
			} else if (mode === 'EXTENSION') {
				res = {
					data: await storage.get('folders')
				};
			}
			return res;
		},
		async addFolder(data) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/folders', { folder: data });
				if (res) {
					res = res.data;
				}
			} else if (mode === 'EXTENSION') {
				res = createFolder(data);
				let folders = (await storage.get('folders')) || [];
				folders.push(res);
				await storage.set('folders', folders);
			}
			return res;
		},
		async updateFolder(folder) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('put', `/folders/${folder._id}`, {
					folder: folder
				});
			} else if (mode === 'EXTENSION') {
				res = true;
				let folders = (await storage.get('folders')) || [];
				folders = folders.map(f => {
					if (f._id === folder._id) {
						f = folder;
					}
					return f;
				});
				await storage.set('folders', folders);
			}
			return res;
		},
		async removeFolder(folderId) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('delete', `/folders/${folderId}`);
				res = true;
			} else if (mode === 'EXTENSION') {
				res = true;
				let folders = (await storage.get('folders')) || [];
				if (folders.length > 0) {
					folders = folders.filter(f => {
						if (f._id === folderId) {
							return false;
						} else {
							return true;
						}
					});
					await storage.set('folders', folders);
				}
			}
			return res;
		}
	},

	buckets: {
		async getBuckets() {
			let res = [];
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/buckets/all');
			} else if (mode === 'EXTENSION') {
				res = {
					data: (await storage.get('buckets')) || []
				};
			}
			return res;
		},
		async addBucket(data) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/buckets', { bucket: data });
				if (res) {
					res = res.data;
				}
			} else if (mode === 'EXTENSION') {
				res = createBucket(data);
				let buckets = (await storage.get('buckets')) || [];
				buckets.push(res);
				await storage.set('buckets', buckets);
			}
			return res;
		},
		async updateBucket(bucket) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('put', `/buckets/${bucket._id}`, {
					bucket: bucket
				});
			} else if (mode === 'EXTENSION') {
				res = true;
				let buckets = (await storage.get('buckets')) || [];
				buckets = buckets.map(f => {
					if (f._id === bucket._id) {
						f = bucket;
					}
					return f;
				});
				await storage.set('buckets', buckets);
			}
			return res;
		},
		async removeBucket(bucketId) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('delete', `/buckets/${bucketId}`);
				res = true;
			} else if (mode === 'EXTENSION') {
				res = true;
				let buckets = (await storage.get('buckets')) || [];
				if (buckets.length > 0) {
					buckets = buckets.filter(f => {
						if (f._id === bucketId) {
							return false;
						} else {
							return true;
						}
					});
					await storage.set('buckets', buckets);
				}
			}
			return res;
		}
	},

	notes: {
		async getNotes() {
			let res = [];
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/notes/all');
			} else if (mode === 'EXTENSION') {
				res = {
					data: (await storage.get('notes')) || []
				};
			}
			return res;
		},
		// async addBucket(data) {
		// 	let res = false;
		// 	if (mode === 'WEBAPP') {
		// 		res = await http.request('post', '/buckets', { bucket: data });
		// 		if (res) {
		// 			res = res.data;
		// 		}
		// 	} else if (mode === 'EXTENSION') {
		// 		res = createBucket(data);
		// 		let buckets = (await storage.get('buckets')) || [];
		// 		buckets.push(res);
		// 		await storage.set('buckets', buckets);
		// 	}
		// 	return res;
		// },
		async updateNote(note) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('put', `/notes/${note._id}`, {
					note: note
				});
			} else if (mode === 'EXTENSION') {
				res = true;
				let notes = (await storage.get('notes')) || [];
				notes = notes.map(f => {
					if (f._id === note._id) {
						f = note;
					}
					return f;
				});
				await storage.set('notes', notes);
			}
			return res;
		},
		async removeNote(noteId) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('delete', `/notes/${noteId}`);
				res = true;
			} else if (mode === 'EXTENSION') {
				res = true;
				let notes = (await storage.get('notes')) || [];
				if (notes.length > 0) {
					notes = notes.filter(f => {
						if (f._id === noteId) {
							return false;
						} else {
							return true;
						}
					});
					await storage.set('notes', notes);
				}
			}
			return res;
		}
	},

	users: {
		async login(form) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/users/login', form);
			} else if (mode === 'EXTENSION') {
				res = {
					data: await storage.get('user')
				};
			}
			return res;
		},
		async setToken(token) {
			let res = await storage.set('token');
			return res;
		},
		async getNotes() {
			let res = [];
			if (mode === 'WEBAPP') {
				res = await http.request('post', '/notes/all');
			} else if (mode === 'EXTENSION') {
				res = {
					data: await storage.get('notes')
				};
			}
			return res;
		},
		// async addBucket(data) {
		// 	let res = false;
		// 	if (mode === 'WEBAPP') {
		// 		res = await http.request('post', '/buckets', { bucket: data });
		// 		if (res) {
		// 			res = res.data;
		// 		}
		// 	} else if (mode === 'EXTENSION') {
		// 		res = createBucket(data);
		// 		let buckets = (await storage.get('buckets')) || [];
		// 		buckets.push(res);
		// 		await storage.set('buckets', buckets);
		// 	}
		// 	return res;
		// },
		async updateNote(note) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('put', `/notes/${note._id}`, {
					note: note
				});
			} else if (mode === 'EXTENSION') {
				res = true;
				let notes = (await storage.get('notes')) || [];
				notes = notes.map(f => {
					if (f._id === note._id) {
						f = note;
					}
					return f;
				});
				await storage.set('notes', notes);
			}
			return res;
		},
		async removeNote(noteId) {
			let res = false;
			if (mode === 'WEBAPP') {
				res = await http.request('delete', `/notes/${noteId}`);
				res = true;
			} else if (mode === 'EXTENSION') {
				res = true;
				let notes = (await storage.get('notes')) || [];
				if (notes.length > 0) {
					notes = notes.filter(f => {
						if (f._id === noteId) {
							return false;
						} else {
							return true;
						}
					});
					await storage.set('notes', notes);
				}
			}
			return res;
		}
	}
};
